export enum PAGES {
  ROOT = "/",
  EDIT_PROFILE = "/profile/edit",
  POSITIONS = "/profile/positions",
  HISTORIES = "/profile/histories",
  EVENTS = "/profile/events",
  EVENT_DETAIL = "/detail/:id",
  NOTIFICATIONS = "/profile/notifications",
  REFERALS = "/profile/referals",
  FAVORITES = "/profile/favorites",
  TERMS = "/terms",
  ERROR_404 = "*",
}

export enum MODALS {
  SIGN_UP = "/sign-up",
  SIGN_IN = "/sing-in",
  VERIFY_CODE = "/verfy",
  FORGET_PASSWORD = "/forget-password",
  SEND_RESET_CODE = "/send-reset-code",
  RESET_PASSWORD = "/reset-password",
  DEPOSIT = "/deposit",
  DEPOSIT_ADDRESS = "/deposit-address",
  WITHDRAW = "/withdraw",
  WITHDRAW_FORM = "/withdraw-form",
  CRYPTO_LIST = "/crypto-list",
}
export type ParsedSearchParams = Record<string, string>;

export type Scheme<Endpoints extends PAGES | MODALS = PAGES | MODALS> = {
  scheme: Endpoints;
  params?: Record<string, string>;
  getParams?: ParsedSearchParams;
};

export type ParsedPathname = string[];

export type Path = {
  pathname: string;
  search?: string;
};

export type FeScheme = Scheme<PAGES> | [Scheme<PAGES>];
